// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"0559385e","751":"9143290f"}[chunkId] + ".chunk.js";
};